import React, { CSSProperties, memo } from 'react';

import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { UiOuterLink } from 'src/components/UI/OuterLink';
import { resources } from 'src/config/resources';
import { BrandingModelSelectorType } from 'src/models/Branding/BrandingModel';
import { numberOrDefaultNumber } from 'src/utils/numbers';
import { normalizeSchemaUrl } from 'src/utils/url';
import classNames from 'classnames';

type BrandLogoProps = {
  btnMenuHidden: boolean;
  brandingModel: BrandingModelSelectorType;

  hideRallyUpLogo?: boolean;
  className?: string;
  noClassImage?: boolean;
};

export const BrandLogo: React.FC<BrandLogoProps> = memo(
  ({ brandingModel, hideRallyUpLogo, btnMenuHidden, className, noClassImage }: BrandLogoProps) => {
    const logoStyle: CSSProperties = React.useMemo(
      () => ({
        height: numberOrDefaultNumber(brandingModel.data.LogoHeight, 40),
      }),
      [brandingModel.data.LogoHeight]
    );

    if (brandingModel.loading || (brandingModel.data.BrandLogoUri && hideRallyUpLogo)) {
      return null;
    }

    const linkClasses = className || `logo verticalcenter${btnMenuHidden ? ' no-left-v' : ''}`;

    return brandingModel.data.BrandLogoUri ? (
      <UiOuterLink
        className={linkClasses}
        href={normalizeSchemaUrl(brandingModel.data.HeaderLogoLink || '')}
        style={logoStyle}
      >
        <img
          src={brandingModel.data.BrandLogoUri}
          alt=""
          className={classNames({ verticalcenter: !noClassImage })}
          style={logoStyle}
          loading="lazy"
        />
      </UiOuterLink>
    ) : (
      <UiInnerNotSPALink className={linkClasses} href="" style={logoStyle}>
        <img
          src={resources.images.appDefaultLogo}
          className={classNames({ 'brand-logo img-fluid verticalcenter': !noClassImage })}
          alt=""
          style={logoStyle}
        />
      </UiInnerNotSPALink>
    );
  }
);
